import { useRoutes } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/utils/ScrollToTop';
import Seo from './components/Seo';
import { routes } from './routes';

// Внутреннее дерево без <Router> — роутер оборачивает снаружи:
// BrowserRouter в main.jsx (клиент), StaticRouter в entry-server.jsx (пререндер).
export default function AppShell() {
  const element = useRoutes(routes);
  return (
    <>
      <Seo />
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-brand-bg text-brand-text font-inter">
        <Navbar />
        <main className="flex-grow">{element}</main>
        <Footer />
      </div>
    </>
  );
}
